import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Routes from './Routes';
import configureStore from '../Store/configureStore';
import initialState from '../Store/InitialState.config';
import AppLayout from './App.Layout'
import DashboardLayout from '../components/container/Layout/AppLayout'
import * as Routers from './Routers';
import Loader from '../components/presentational/Loader/Loader'

function RouteWithLayout({ layout, component, ...rest }) {
  return (
    <Route {...rest} render={(props) =>
      React.createElement(layout, props, React.createElement(component, props))
    } />
  );
}

const AppRouter = () => (
  <Provider store={configureStore({ initialState })}>
    <Router>
      <Suspense fallback={<Loader />}>
        <Switch>
          {/* withOut Layout */}
          <RouteWithLayout exact layout={AppLayout} path={Routes.REGISTRATION} component={Routers.Register} />
          <RouteWithLayout exact layout={AppLayout} path={Routes.LOGIN} component={Routers.Login} />
          <RouteWithLayout exact layout={AppLayout} path={Routes.LAYOUT} component={Routers.Layout} />
          <RouteWithLayout exact layout={AppLayout} path={Routes.TEST} component={Routers.TestPage} />


          {/* <RouteWithLayout exact layout={AppLayout} path={Routes.STACK_PROCESSING} component={Routers.StackProcessingPage} /> */}

          <RouteWithLayout exact layout={DashboardLayout} path={Routes.DASHBOARD} component={Routers.DashboardPage} />
          <RouteWithLayout exact layout={DashboardLayout} path={Routes.SEARCH} component={Routers.SearchPage} />
          <RouteWithLayout exact layout={DashboardLayout} path={Routes.INSIGHTS} component={Routers.InsightsPage} />
          <RouteWithLayout exact layout={DashboardLayout} path={Routes.MY_LIST} component={Routers.MyListPage} />
          <RouteWithLayout exact layout={DashboardLayout} path={Routes.MY_SAVED_SEARCH} component={Routers.MySavedSearchPage} />
          <RouteWithLayout exact layout={DashboardLayout} path={Routes.MY_PREFERENCES} component={Routers.MyPreferencesPage} />
          <RouteWithLayout exact layout={DashboardLayout} path={Routes.MY_KOGNETICS} component={Routers.MyKogneticsPage} />
          <RouteWithLayout exact layout={DashboardLayout} path={Routes.PROFILE_PAGE} component={Routers.ProfilePage} />
          <RouteWithLayout exact layout={DashboardLayout} path={Routes.COMPANY_PROFILE} component={Routers.CompanyProfilePage} />
          <RouteWithLayout exact layout={DashboardLayout} path={Routes.INVESTOR_PROFILE} component={Routers.InvestorProfilePage} />
        </Switch>
      </Suspense>
    </Router>
  </Provider>
)

export default AppRouter;
